import React from "react";
import {ArrowLeftIcon, ArrowRightIcon} from "./svgs";

export const CustomIconRef = React.forwardRef(({
                                                 className,
                                                 size = "base",
                                                 icon,
                                                 ...props
                                               }, ref) => (
  <span ref={ref}
        className={`${className ? `${className} ` : ''}material-icons text-${size} leading-none`} {...props}>
      {icon}
    </span>
));

const CustomIcon = ({className, icon, size = "base", ...props}) => {

  return (
    <span
      className={`${className ? `${className} ` : ''}material-icons select-none text-${size} leading-none`} {...props}>
      {icon}
    </span>
  );
};

export default CustomIcon;

export const RoundedCustomButton = ({
                                      className,
                                      icon,
                                      size = "base",
                                      isArrowButton = true,
                                      isLeft = true,
                                      hasShadow = true,
                                      disabled = false,
                                      onClick,
                                      ...props
                                    }) => {

  return (
    <CustomIcon
      onClick={disabled ? undefined : onClick}
      className={`transition text-black p-1.5 bg-white rounded-full ${disabled ? "opacity-50 cursor-not-allowed" : "hover:bg-neutral-light cursor-pointer"} ${hasShadow ? 'shadow-md' : ""} w-8 h-8${className ? ` ${className}` : ''}`}
      icon={isArrowButton ? isLeft ? <ArrowLeftIcon size="w-[20px]"/> : <ArrowRightIcon size="w-[20px]"/> : icon}
      size={size} {...props}/>
  );
};


